import { CachedProcesses, CachedProcessesProps, Process } from 'admin/api/processes';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { keyBy } from 'shared/utils/converter';

/**
 * プロセス一覧を取得するcustom hooks
 */
export const useProcesses = ({ tenant_id, filter_method }: CachedProcessesProps) => {
  const [processes, setProcesses] = useState<Process[] | undefined>(undefined);
  const processes_record: Record<string, Process> = useMemo(() => {
    return processes ? keyBy(processes, (p) => p.process_id) : {};
  }, [processes]);
  const loadProcesses = useCallback(
    async (request?: CachedProcessesProps) => {
      const r = request ?? { tenant_id, filter_method } ?? {};
      const new_processes = await new CachedProcesses(r).get();
      setProcesses(new_processes);
    },
    [tenant_id, filter_method],
  );

  useEffect(() => {
    loadProcesses();
  }, [loadProcesses]);

  return useMemo(() => {
    return {
      processes,
      processes_record,
      setProcesses,
      loadProcesses,
    };
  }, [processes, processes_record, setProcesses, loadProcesses]);
};
